import React from "react";
import {useHistory, useLocation} from "react-router-dom";
import Router from "router/router";

import * as Api from "api/api";
import {Form, message} from "antd";
import * as cssInJs from "./css/login-form";
import * as css from "./css/loginForm.module.scss";
import {observer} from "mobx-react";
import useMyStores from "../../hooks/useMyStores";
import classNames from "classnames";

const Index = ({className}) => {
    const {login: store, user} = useMyStores()

    const history = useHistory();
    const location = useLocation();

    const [form] = Form.useForm()

    const toRegister = () => {
        history.replace({
            pathname: Router.Register.path
        });
    };

    const onFinish = async (values) => {
        try {
            await Api.login(values);

            message.success("登录成功");
            await user.login();
            window.location.reload();
            store.show = false;
        } catch (error) {
            const errMsg = error.response.data.msg;
            message.error(errMsg);
        } finally {
        }
    }

    const formInitialValues = {
        username: '',
        password: ''
    }
    return (
        <cssInJs.LoginForm className={className}>
            <cssInJs.BgImg src={require("./img/bg.png")}/>
            <button
                className="close"
                onClick={() => {
                    store.show = false;
                }}
            >
                <div className="bg"></div>
            </button>
            <cssInJs.TitleFloor>
                <cssInJs.TitleText src={require("./img/title-text.png")}></cssInJs.TitleText>
                <cssInJs.TitleBgImg src={require("./img/title-bg.png")}/>
            </cssInJs.TitleFloor>

            <Form className={css.antdLoginForm} onFinish={onFinish} initialValues={formInitialValues} form={form}>
                <Form.Item className={classNames(css.formItem, css.first)}>
                    <cssInJs.InputIcon src={require("./img/username-icon.png")}/>
                    <cssInJs.BgImg src={require("./img/input-img.png")}/>
                    <Form.Item noStyle name='username' rules={[
                        {
                            required: true,
                            message: "请输入用户名"
                        }
                    ]}>

                        <input
                            className={css.input}
                            placeholder="用户名/邮箱/手机号"
                        />
                    </Form.Item>
                </Form.Item>
                <Form.Item className={css.formItem}>
                    <cssInJs.InputIcon src={require("./img/password-icon.png")}/>
                    <cssInJs.BgImg src={require("./img/input-img.png")}/>
                    <Form.Item noStyle name='password' rules={[{
                        required: true,
                        message: "请输入密码"
                    }]}>
                        <input
                            className={css.input}
                            type="password"
                            placeholder="密码"
                        />
                    </Form.Item>
                </Form.Item>
                <cssInJs.SaveBlock>
                    <cssInJs.RegisterText onClick={toRegister}>
                        前往注册
                    </cssInJs.RegisterText>
                    <cssInJs.RegisterIcon
                        src={require("./img/register-icon.png")}
                        onClick={toRegister}
                    />
                </cssInJs.SaveBlock>
                <cssInJs.LoginButton>
                    <cssInJs.BgImg src={require("./img/login-bg.png")}/>
                    登录
                </cssInJs.LoginButton>
            </Form>
        </cssInJs.LoginForm>
    );
}


export default observer(Index);
